module.exports = "<div class=\"type\">\n  <div >\n  {{question_index}}<span class=\"mandatory\" *ngIf=\"is_mandt\">*</span>. {{question_name}}\n  </div>\n  <div>\n  {{question_name_second}}\n  </div>\n  <input id=\"test\" [attr.maxLength]=\"question_max_char\" type=\"text\" [attr.value]=\"response\" (keyup.enter)=\"entered($event)\" (blur)=\"entered($event)\" >\n</div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/questions-type/subjective-type/subjective-type.component.html
// module id = ./src/app/questions-type/subjective-type/subjective-type.component.html
// module chunks = main